import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getCurrentOrCustomerProfileSelect } from '../get-current-or-customer'

export function getCurrentOrCustomerIdProfileSelect (state) {
  return getIdReduxUtil(getCurrentOrCustomerProfileSelect(state))
}
